var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93258 12.087L4.23639 14.686L1.6918 14.7398C0.931344 13.3294 0.5 11.7156 0.5 10.0007C0.5 8.34238 0.903296 6.77858 1.61817 5.40161H1.61871L3.88411 5.81694L4.87649 8.06874C4.66879 8.67427 4.55558 9.32429 4.55558 10.0007C4.55566 10.7348 4.68863 11.4381 4.93258 12.087Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3253 8.13232C20.4401 8.73727 20.5 9.36202 20.5 10.0005C20.5 10.7165 20.4247 11.4149 20.2813 12.0885C19.7945 14.3809 18.5225 16.3826 16.7603 17.7992L16.7598 17.7986L13.9064 17.653L13.5026 15.132C14.6718 14.4463 15.5856 13.3732 16.0669 12.0885H10.7195V8.13232H16.145H20.3253Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7613 17.7983L16.7618 17.7989C15.0481 19.1764 12.871 20.0006 10.5012 20.0006C6.69281 20.0006 3.38171 17.872 1.69263 14.7394L4.93341 12.0866C5.77793 14.3405 7.95219 15.945 10.5012 15.945C11.5968 15.945 12.6233 15.6488 13.504 15.1318L16.7613 17.7983Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8828 2.30227L13.6431 4.95456C12.7316 4.38477 11.654 4.05562 10.4996 4.05562C7.89293 4.05562 5.67801 5.73369 4.87579 8.06842L1.61798 5.40129H1.61743C3.28179 2.19238 6.63465 0 10.4996 0C12.9261 0 15.1509 0.864328 16.8828 2.30227Z",
    fill: "#F14336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9e40ec55be3eebdfee7e0a76d8594ae8.svg";
export { ForwardRef as ReactComponent };